function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { AutoUpdatingLoader, Embedded } from '@cerbos/embedded';
import { env } from '@repo/environment';
import { CerbosLogger } from './cerbos.logger';
const embeddedCache = {};
function createCerbosEmbedded(bundleUrl) {
    if (!embeddedCache[bundleUrl]) {
        embeddedCache[bundleUrl] = new Embedded(new AutoUpdatingLoader(bundleUrl, {
            interval: 10800000
        })); // 3 hours
    }
    return embeddedCache[bundleUrl];
}
export class CerbosEmbeddedEngine {
    initialize() {
        if (this.initialized) {
            return;
        }
        this.embedded = createCerbosEmbedded(this.bundleUrl);
        this.initialized = true;
    }
    async isAllowed(request) {
        if (!this.initialized) {
            this.initialize();
        }
        if (!this.embedded) {
            this.logger.error({
                message: 'Cerbos Embedded not initialized',
                error: new Error('Cerbos Embedded not initialized'),
                request
            });
            throw new Error('Cerbos Embedded not initialized');
        }
        const result = await this.embedded.isAllowed(request);
        return result;
    }
    async check(request) {
        if (!this.initialized) {
            this.initialize();
        }
        if (!this.embedded) {
            this.logger.error({
                message: 'Cerbos Embedded not initialized',
                error: new Error('Cerbos Embedded not initialized'),
                request: {
                    principal: request.principal,
                    resource: request.resource,
                    action: request.actions[0]
                }
            });
            throw new Error('Cerbos Embedded not initialized');
        }
        const results = {};
        const promises = request.actions.map((action)=>{
            var _this_embedded;
            return (_this_embedded = this.embedded) === null || _this_embedded === void 0 ? void 0 : _this_embedded.isAllowed({
                principal: request.principal,
                resource: request.resource,
                action
            });
        });
        const allowedResults = await Promise.all(promises);
        request.actions.forEach((action, idx)=>{
            var _allowedResults_idx;
            results[action] = (_allowedResults_idx = allowedResults[idx]) !== null && _allowedResults_idx !== void 0 ? _allowedResults_idx : false;
        });
        return results;
    }
    getStatus() {
        return {
            initialized: this.initialized,
            bundleUrl: this.bundleUrl
        };
    }
    constructor(){
        _define_property(this, "embedded", null);
        _define_property(this, "initialized", false);
        _define_property(this, "bundleUrl", env.PUBLIC_CERBOS_HUB_BUNDLE_URL);
        _define_property(this, "logger", new CerbosLogger('CerbosEmbeddedEngine', env.PUBLIC_USE_SENTRY));
    }
}
export const cerbosEngine = new CerbosEmbeddedEngine();
